import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { c as h } from "../../../clsx-OuTLNxxd.js";
import { B as m } from "../../../button.types-AwV8CUDS.js";
import "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
import { T as o } from "../../../text-Dyl3qmwR.js";
import { BANNER_COLOR as f } from "./banner.types.js";
import { ImageResponsive as d } from "./image/image.js";
const b = "_banner_17hqf_29", n = {
  "banner-container": "_banner-container_17hqf_29",
  banner: b,
  "banner-image": "_banner-image_17hqf_39",
  "banner-content": "_banner-content_17hqf_42",
  "banner-text": "_banner-text_17hqf_48",
  "banner-cta": "_banner-cta_17hqf_51",
  "is-info": "_is-info_17hqf_92",
  "is-warning": "_is-warning_17hqf_95",
  "is-success": "_is-success_17hqf_98",
  "is-error": "_is-error_17hqf_101",
  "is-neutral": "_is-neutral_17hqf_104",
  "dialog-overlay-show": "_dialog-overlay-show_17hqf_1",
  "dialog-content-show": "_dialog-content-show_17hqf_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17hqf_1"
};
function B({ color: i, image: s, className: t, cta: r, title: _, description: c }) {
  const l = h(n.banner, n[f[i]], t);
  return /* @__PURE__ */ e("div", { className: n["banner-container"], children: /* @__PURE__ */ a("div", { className: l, children: [
    s && /* @__PURE__ */ e(d, { className: n["banner-image"], ...s }),
    /* @__PURE__ */ a("div", { className: n["banner-content"], children: [
      /* @__PURE__ */ a("div", { className: n["banner-text"], children: [
        /* @__PURE__ */ e(o, { isBold: !0, className: n.title, children: _ }),
        /* @__PURE__ */ e(o, { className: n.description, children: c })
      ] }),
      r && /* @__PURE__ */ e(m, { className: n["banner-cta"], color: r.color, onClick: r.onClick, children: r.text })
    ] })
  ] }) });
}
export {
  B as Banner
};
